import {
  mdiCheckboxBlankCircleOutline,
  mdiCheckboxMarkedCircle
} from '@mdi/js';
import { getTheme } from '@prz-dp/ui';
import Vue from 'vue';
import Vuetify from 'vuetify';

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: 'mdiSvg',
    values: {
      checkboxBlankCircleOutline: mdiCheckboxBlankCircleOutline,
      checkboxMarkedCircle: mdiCheckboxMarkedCircle
    }
  },
  theme: {
    options: {
      customProperties: true
    },
    themes: {
      light: {
        ...getTheme()
      }
    }
  }
});
